import {
    CLAIMS_GENERATED_PRESIGNED_URLS,
    CLAIMS_ATTACHMENTS_SAVED_ERROR,
    CLAIMS_TICKET_ATTACHMENTS_SAVED
} from '../../constants/websocketCommands';
import {
    CLAIMS_ATTACHMENTS_UPLOADING,
    CLAIMS_ATTACHMENTS_UPLOADING_ERROR
} from '../../actions/claims/actionClaimsAttachments';
import {CLAIMS_TICKET_RESET} from '../../actions/claims/actionClaimsTicket';

export const claimsAttachment = (state = {
    correlationId: null,
    isTicketAttachmentUploading: false,
    attachmentsForUpload: [],
}, action) => {
    switch (action.type) {
        case CLAIMS_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case CLAIMS_GENERATED_PRESIGNED_URLS: {
            const {attachments} = action.payload;
            return Object.assign({}, state, {
                attachmentsForUpload: Array.isArray(attachments) ? attachments : [],
            });
        }
        case CLAIMS_ATTACHMENTS_UPLOADING: {
            return Object.assign({}, state, {isTicketAttachmentUploading: true});
        }
        //att done + error
        case CLAIMS_ATTACHMENTS_SAVED_ERROR:
        case CLAIMS_ATTACHMENTS_UPLOADING_ERROR: {
            return Object.assign({}, state, {
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case CLAIMS_TICKET_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        default:
            return state;
    }
};
